import { Api } from 'models/services/api';
import { DeleteOriginalMenuCategoryQuery } from 'models/services/graphql';

import { OriginalMenuCategoryData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteOriginalMenuCategory($id: ID!) {
    ${DeleteOriginalMenuCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    deleteOriginalMenuCategory: OriginalMenuCategoryData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: OriginalMenuCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw 'invalid response';
    const document = api.response.data.deleteOriginalMenuCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };